export const unescapeHTML = (escapedHTML) => {
  if (escapedHTML == null) {
    return escapedHTML;
  }
  return escapedHTML
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&");
};
